<template>
  <div class="member-item-select" tabindex="1" @click="emit('select', !props.selected)">
    <div class="name">
      <Avatar :name="member.name" :url="previewFile(member.avatar)"></Avatar>
      <div class="flex-1">
        <div class="flex items-center">
          <div>{{ member.employeeName }}</div>
          <div class="account hover-item">(ID: {{ member.loginName }})</div>
        </div>
        <div class="email">{{ member.email }}</div>
      </div>
    </div>
    <slot>
      <a-checkbox
        :checked="selected"
        @change="(e: any) => emit('select', e.target.checked)"
      ></a-checkbox>
    </slot>
    <!-- <div class="department">{{ member.departments }}</div> -->
    <!-- <div class="status">{{ member.stateName }}</div> -->
    <!-- <div class="date">{{ member.createdTime?.split(' ')[0] }}</div> -->
    <!-- <div class="operator">
      <Menu :menus="operators" @click="e => emit(e)">
        <EllipsisOutlined
          class="hover-item cursor-pointer"
          style="font-size: 16px"
          tabindex="-1"
        ></EllipsisOutlined>
      </Menu>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { Avatar } from '@elecmap/elecmap-ui'
import type { EmployeePageQuery } from '@elecmap/api/src/ram.d'
import { previewFile } from '@elecmap/api/src/cad/file'

const props = defineProps<{
  member: EmployeePageQuery
  selected: boolean
}>()

const emit = defineEmits(['select'])
</script>

<style lang="less" scoped>
.member-item-select {
  cursor: pointer;
  display: flex;
  width: calc(100% + 16px);
  transform: translateX(-8px);
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  transition: all 0.28s;
  border-radius: 5px;

  .name {
    display: flex;
    align-items: center;
    > div {
      margin-right: 8px;
    }
    :deep(.ant-avatar) {
      border-radius: 50%;
    }
    .account {
      transition: all 0.28s;
      margin: 0 4px;
      color: #bbb;
    }
    .edit-icon {
      transition: all 0.28s;
      cursor: pointer;
    }
  }

  .role {
    cursor: pointer;
  }

  &:hover,
  &:focus {
    background-color: #f5f5f5;
  }

  &:focus {
    .hover-item {
      opacity: 1;
    }
  }
}
</style>
